import { Box, Button, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import React from 'react'
import Lottie from "lottie-react";
import { commonCss } from '../../../CssStyle/commonCss'
import custom from "../../../Images/Service/customSolution.json"
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Custom = ({mt,direction,title,subtitle,description,lottieImage,listTitle,listName,width,id,styleSX,displayDesc,spacing}) => {
    const navigate=useNavigate()
  return (
    <Grid2 id={id} container justifyContent={"center"} alignItems={"center"} flexDirection={direction} size={{xs:12}} spacing={spacing} sx={styleSX}>
      <Grid2 container alignItems={"center"} size={12} sx={{ mt:mt,maxWidth:{xs:"auto",xl:"2000px"}}}>
       <Grid2 size={{xs:12,md:6}} >
           <Typography variant='h2' sx={{fontSize:{xs:"1.5rem",md:"2rem"},fontWeight:700,textTransform:"uppercase",mb:"1rem",color:commonCss.blue}}>{title}</Typography>
           <Typography variant='h5' sx={{fontSize:{xs:"1.5rem",md:"2rem"},fontWeight:500,lineHeight:"normal",mb:"1rem",width:{xs:"100%",md:"80%"}}}>
           {subtitle}
           </Typography>
           <Typography  sx={{display:displayDesc?"default":"none",fontSize:"1.5rem",width:{xs:"100%",md:"80%"},mb:"1rem"}}>
           {description}
           </Typography>
           <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4,display:displayDesc?"default":"none",}}>{listTitle}</Typography>
                       <List sx={{'& .MuiListItemText-primary': {
                         fontFamily: 'Roboto, sans-serif', 
                         fontSize:"1rem",
                         fontWeight:600
                       },
                       display:"flex",
                       columnGap:"1rem",
                       rowGap:"0.5rem",
                       flexWrap:"wrap",
                       width:'100%',
                       mt:"1rem"
                       }} >
                        {listName.map((listData,i)=>(
                            <ListItem key={i} sx={{p:0,width:{xs:"100%",md:width}}}>
                           <ListItemIcon>
                               <ArrowForward />
                             </ListItemIcon>
                             <ListItemText >{listData}</ListItemText>
                           </ListItem>
                        ))}
                           
                           
                           
                       </List>

                       <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding:"0.5rem",
                  textTransform:"none",
                  width:{xs:"60%",md:"40%"},
                  fontWeight:500,
                  fontSize:"0.95rem",
                  mt:"1rem",
                  borderRadius:"30px",
                  ":hover":{
                    background:commonCss.blue,
                  
                  }
                }}

                onClick={()=>{navigate("/contactus")}}
              >
                Expert Help Here
              </Button>          
       </Grid2>
       <Grid2 size={{xs:12,md:6}}>
        <Box sx={{ mt: "-4rem" }}>
       <Lottie animationData={lottieImage} loop={true} />
       </Box>
       </Grid2>
       </Grid2>
    </Grid2>
  )
}

export default Custom